// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentSurvey {
    static getAttributeTypeMap() {
        return BasicEnrollmentSurvey.attributeTypeMap;
    }
}
BasicEnrollmentSurvey.discriminator = undefined;
BasicEnrollmentSurvey.additionalProperties = false;
BasicEnrollmentSurvey.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "questions",
        "baseName": "questions",
        "type": ""
    },
];
//# sourceMappingURL=basicEnrollmentSurvey.js.map